/* 系統配置相關接口 */

import request from '@/utils/http/request'



/* 運動類型 */



//運動類型列表
export async function sportType_list({ typeCode, name, pageSize, pageNumber }) {
    return await request.get('/sportType', {
        params: {
            typeCode, name, pageSize, pageNumber
        }
    });
}

//運動類型詳情
export async function sportType_detail(id) {
    return await request.get(`/sportType/${id}`);
}

//運動類型添加
export async function sportType_add({ name, imageUrl, status }) {
    return await request.post('/sportType', {
        name, imageUrl, status
    });
}

//更新運動類型
export async function sportType_update({ id, name, imageUrl, status }) {
    return await request.put(`/sportType/${id}`, {
        name, imageUrl, status
    });
}

//運動類型刪除
export async function sportType_del(id) {
    return await request.delete(`/sportType/${id}`);
}



/* 廣告 */

export async function advertisement_list({ adType, displayPosition, adName, pageSize, pageNumber }) {
    return await request.get('/advertisement', {
        params: {
            adType, displayPosition, adName, pageSize, pageNumber
        }
    });
}


export async function advertisement_detail(id) {
    return await request.get(`/advertisement/${id}`);
}


export async function advertisement_add({ adName, imageUrl, redirectUrl, adType, displayPosition, positionDesc, sortOrder }) {
    return await request.post('/advertisement', {
        adName, imageUrl, redirectUrl, adType, displayPosition, positionDesc, sortOrder
    });
}


export async function advertisement_update({ id, adName, imageUrl, redirectUrl, positionDesc, sortOrder }) {
    return await request.put('/advertisement', {
        id, adName, imageUrl, redirectUrl, positionDesc, sortOrder
    });
}


export async function advertisement_del(id) {
    return await request.delete(`/advertisement/${id}`);
}

/* 區域資訊 */

export async function area_list(parentCode) {
    return await request.get(`/area`, {
        params: {
            parentCode
        }
    });
}


/**
 * 文件上傳
 * @param {String} bizType 文件類型 avatar-用戶頭像、ifBG-卡片背景圖、cert-接口參數
 * @returns 
 */
export async function oss_files(bizType, data) {
    return await request({
        url: `/ossFiles/${bizType}`,
        method: 'post',
        data: data,
        headers: { 'Content-Type': 'multipart/form-data;charset=utf-8' },
    })
}



/* 品牌活動列表 */
export async function activity_list({ name, pageNumber, pageSize }) {
    return await request.get('/activity', {
        params: {
            name, pageNumber, pageSize
        }
    });
}

/* 品牌活動添加 */
export async function activity_insert({ name, image, num, amount, author, remark, videoUrl, status, pageNumber, pageSize }) {
    return await request.post('/activity', {
        name, image, num, amount, author, remark, videoUrl, status, pageNumber, pageSize
    });
}
/* 品牌活動編輯 */
export async function activity_update({ id, name, image, num, amount, author, remark, videoUrl, status, pageNumber, pageSize }) {
    return await request.put(`/activity/${id}`, {
        name, image, num, amount, author, remark, videoUrl, status, pageNumber, pageSize
    });
}

/* 品牌活動資訊 */
export async function activity_detail(id) {
    return await request.get(`/activity/${id}`, {});
}

/* 品牌活動刪除 */
export async function activity_del(id) {
    return await request.delete(`/activity/${id}`, {});
}



/* 發票列表 */
export async function invoice_list({ name, pageNumber, pageSize }) {
    return await request.get(`/invoice`, {
        params: {
            name, pageNumber, pageSize
        }
    });
}
/* 發票審核 */
export async function invoice_status(id) {
    return await request.put(`/invoice/status/${id}`, {});
}

/* 黑名單列表 */
export async function blacklist({ name, phone, pageNumber, pageSize }) {
    return await request.get(`/blacklist`, {
        params: {
            name, phone, pageNumber, pageSize
        }
    });
}

/* 加入黑名單 */
export async function blacklist_insert({ memberCode, day }) {
    return await request.post(`/blacklist`, {
        memberCode, day
    });
}

/* 移除黑名單 */
export async function blacklist_del(id) {
    return await request.delete(`/blacklist/${id}`, {
        memberCode, day
    });
}


/* 獲取系統配置資訊 */
export async function sysConfigs_applicationConfig() {
    return await request.get(`/sysConfigs/applicationConfig`, {});
}

/* 更新係統配置 */
export async function sysConfigs_applicationConfig_insert(data) {
    const formData = new FormData();
    for (let i = 0; i < data.length; i++) {
        const item = data[i];
        formData.append(item.key, item.value);
    }
    return await request.post(`/sysConfigs/applicationConfig`, formData);
}